import React, { useState, useEffect, useRef } from "react"

import "../../Forms/Form.css"
import "../../../Components/Commons/Commons.css"

import BtnPrint from "../../Commons/Buttons/BtnPrint"
import ProfileSummary from "./ProfileSummary"

import { toast } from "react-toastify"
// import { Col, Row } from "react-bootstrap";
import { useParams } from "react-router-dom"
import {
  createFormAttachment,
  getMedicalSummary,
} from "../../Helpers/API/CheckUpApi/FormApi"
import { capitalizeFirstLetter, formatDate } from "../../Helpers/Utilities/Common"
// import { FORM } from "../../../Constants/doctor"
// import { Divider } from "antd"
import FormHeader from "../../Commons/FormHeader"
import BtnPrintV2 from "../../Commons/Buttons/BtnPrintV2"

function MedicalSummary({ isFetchData }) {
  const summaryRef = useRef();
  const { id } = useParams()
  const [isUpload, setIsUpload] = useState(false)
  const [allDetails, setAllDetails] = useState(false)
  const [pdfFile, setPdfFile] = useState("")
  const handleSetPdfFile = (data) => {
    setPdfFile(data)
  }

  // TRIGGERED WHEN PRINT BTN IS CLICKED
  const handleSetIsUpload = (data) => {
    setIsUpload(data)
    setTimeout(() => {
      setIsUpload(!data)
    }, 1000)
  }

  // TO UPLOAD FILE
  async function handleUploadFile() {
    const response = await createFormAttachment(id, pdfFile, "Medical Summary")
    if (response.error) {
      response.error?.data?.messages?.error_messages.map((data) => {
        return toast.error(data)
      })
    } else {
      toast.success("Successfully uploaded file!", { autoClose: 1000 })
    }
  }

  // TO FETCH ASSESSMENT DATA
  async function fetchData() {
    const response = await getMedicalSummary(id)

    if (response.data) {
      setAllDetails(response.data.data)
    } else if (response.error) {
    }
  }

  useEffect(() => {
    // TO FETCH DATA WHEN TAB IS SELECTED
    if (isFetchData === "medical_summary") fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFetchData])

  useEffect(() => {
    if (pdfFile !== "" && isUpload) {
      handleUploadFile()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isUpload])

  return (
    <div className="container">
      <div className="pt-5" />
      <div
        id="medical_summary_content"
        className="print-area dotted rounded px-5"
        ref={summaryRef}
      >
        <FormHeader/>
        <div className="row mt-2 d-flex justify-content-center text-center">
          <label>
            {/* <h1>
              <strong>Medical Summary</strong>
            </h1> */}
              <strong style={{ fontSize: "30px" }}>Medical Summary</strong>
          </label>
        </div>
        <div className="row pt-5 d-flex justify-content-center text-left">
          <div className="row">
            <label>
              <h6>
                <strong>PATIENT PROFILE</strong>
              </h6>
            </label>
          </div>
          <div className="row">
            <label>
              <span>Name</span> :{" "}
              <span>
                {allDetails?.patient ? allDetails?.patient[0]?.formatted_patient_name : ""}
              </span>
            </label>
          </div>
          <div className="row">
            <label>
              <span>Age/Sex</span> :{" "}
              <span>
                {allDetails?.patient ? allDetails?.patient[0]?.age : ""} / {allDetails?.patient ? capitalizeFirstLetter(allDetails?.patient[0]?.sex) : ""}
              </span>
            </label>
          </div>
        </div>
        <div className="row pt-5 d-flex justify-content-center text-left">
          <div className="row">
            <label>
              <h6>
                <strong>MEDICAL HISTORY</strong>
              </h6>
            </label>
          </div>
          {allDetails.has_medical_history === 0 && <>No medical history.</>}
          <ProfileSummary
            title={`Allergy Profile`}
            data={allDetails.allergy_profile}
            headers={["Type", "Name"]}
            columns={["type", "name"]}
          />
          <ProfileSummary
            title={`Allergy Profile`}
            data={allDetails.asthma_profile}
            headers={["Duration", "Last Attack"]}
            columns={["duration", "last_attack"]}
          />
          <ProfileSummary
            title={`Diabetes Profile`}
            data={allDetails.diabetes_profile}
            headers={[
              "Duration",
              "Usual FBS",
              "Usual RBS",
              "Hba1c",
              "CBG Range",
              "Complications",
            ]}
            columns={[
              "duration",
              "usual_fbs",
              "usual_rbs",
              "hba1c",
              "cbg_range",
              "complications",
            ]}
          />
          <ProfileSummary
            title={`Drinking Profile`}
            data={allDetails.drinking_profile}
            headers={["Frequency", "Consumption"]}
            columns={["frequency", "consumption"]}
          />
          <ProfileSummary
            title={`Drug Use Profile`}
            data={allDetails.drug_use_profile}
            headers={["Name", "Last Intake"]}
            columns={["name", "last_intake"]}
          />
          <ProfileSummary
            title={`GDM Profile`}
            data={allDetails.gdm_profile}
            headers={[
              "AOG",
              "Fasting",
              "Glucose Load 1h",
              "Glucose Load 2h",
              "Insulin Use",
              "Handout Link",
            ]}
            columns={[
              "aog",
              "fasting",
              "glucose_load_1h",
              "glucose_load_2h",
              "insulin_use",
              "handout_link",
            ]}
          />
          <ProfileSummary
            title={`Herbal Use Profile`}
            data={allDetails.herbal_use_profile}
            headers={["Name", "Duration", "Last Intake"]}
            columns={["name", "duration", "last_intake"]}
          />
          <ProfileSummary
            title={`Herodofamilial Disease Profile`}
            data={allDetails.heredofamilial_disease_profile}
            headers={["Name"]}
            columns={["name"]}
          />
          <ProfileSummary
            title={`Hospitalization Disease Profile`}
            data={allDetails.hospitalization_profile}
            headers={["Name", "Admitted On", "Reason"]}
            columns={["name", "admitted_on", "reason"]}
          />
          <ProfileSummary
            title={`Hypertension Profile`}
            data={allDetails.hypertension_profile}
            headers={["Duration", "Highest BP", "Usual BP"]}
            columns={["duration", "highest_bp", "usual_bp"]}
          />
          <ProfileSummary
            title={`Medication Profile`}
            data={allDetails.medication_profile}
            headers={[
              "Generic",
              "Brand",
              "Preparation",
              "Form",
              "Dosage",
              "Frequency",
              "Timing",
              "Duration",
              "Compliance",
            ]}
            columns={[
              "generic",
              "brand",
              "preparation",
              "form",
              "dosage",
              "frequency",
              "timing",
              "duration",
              "compliance",
            ]}
          />
          <ProfileSummary
            title={`Other Endocrine Disease Profile`}
            data={allDetails.other_endocrine_disease_profile}
            headers={["Name"]}
            columns={["name"]}
          />
          <ProfileSummary
            title={`Other Illness Profile`}
            data={allDetails.other_illness_profile}
            headers={["Name"]}
            columns={["name"]}
          />
          <ProfileSummary
            title={`Pituitary Disorder Profile`}
            data={allDetails.pituitary_disorder_profile}
            headers={["Name"]}
            columns={["name"]}
          />
          <ProfileSummary
            title={`Pre-GDM Profile`}
            data={allDetails.pre_gdm_profile}
            headers={[
              "AOG",
              "Fasting",
              "Glucose Load 1h",
              "Glucose Load 2h",
              "Insulin Use",
              "Handout Link",
            ]}
            columns={[
              "aog",
              "fasting",
              "glucose_load_1h",
              "glucose_load_2h",
              "insulin_use",
              "handout_link",
            ]}
          />
          <ProfileSummary
            title={`Smoking Profile`}
            data={allDetails.smoking_profile}
            headers={["Duration", "Sticks/day"]}
            columns={["duration", "sticks_per_day"]}
          />
          <ProfileSummary
            title={`Thyroid Disorder Profile`}
            data={allDetails.thyroid_disorder_profile}
            headers={[
              "Type",
              "Duration",
              "Medication",
              "Rai",
              "Surgery",
              "Levothyroxine",
              "Histopathologic",
            ]}
            columns={[
              "type",
              "duration",
              "medication",
              "rai",
              "surgery",
              "levothyroxine",
              "histopathologic",
            ]}
          />
          <ProfileSummary
            title={`Vax Profile`}
            data={allDetails.vax_profile}
            headers={["Name", "Taken On", "Next Shot On"]}
            columns={["vax_name", "taken_on", "next_shot_on"]}
          />
        </div>
        <div className="row pt-5 d-flex justify-content-center text-left">
          <div className="row">
            <label>
              <h6>
                <strong>ASSESSMENT HISTORY</strong>
              </h6>
            </label>
          </div>
          <div className="row text-center">
            <div className="col">
              <label>
                <strong>Date</strong>
              </label>
            </div>
            <div className="col">
              <label>
                <strong>Diagnose</strong>
              </label>
            </div>
            <div className="col">
              <label>
                <strong>Medication</strong>
              </label>
            </div>
            <div className="col">
              <label>
                <strong>Plan</strong>
              </label>
            </div>
            <div className="col">
              <label>
                <strong>Type</strong>
              </label>
            </div>
          </div>
          {allDetails?.assessment_history?.map((data) => {
            return (
              <div className="row text-center">
                <hr />
                <div className="col">
                  <label>{formatDate(data.date)}</label>
                </div>
                <div className="col">
                  <label>
                    <ul style={{ listStyleType: 'disc', paddingLeft: '20px', margin: 0 }}>
                      {data.diagnosis
                        .map(diag => (
                          <li key={diag.id}>{diag.diagnosis_name}</li>
                        ))}
                    </ul>
                  </label>
                </div>
                <div className="col">
                  {/* <label>{data.medication}</label> */}
                  <label>{data.medication?.replace(/<br\s*\/?>/gi, ' ')}</label>
                </div>
                <div className="col">
                  <label>{data.plan}</label>
                </div>
                <div className="col">
                  <label>{capitalizeFirstLetter(data.type)}</label>
                </div>
              </div>
            )
          })}
        </div>
      </div>
      <div className="row justify-content-end mt-5 ">
        <div className="col-4">
          <BtnPrintV2
            label={"Save Form"}
            size={"xl"}
            // divId={`medical_summary_${id}`}
            divId={summaryRef}
            fileName={`Summary_${allDetails?.patient ? allDetails?.patient[0]?.full_name : ""}.pdf`}
            paperType={"a4"}
          />
        </div>
      </div>
    </div>
  )
}
export default MedicalSummary
